import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl/dist';
// Constants

import { configs } from '../../constants/configs/configs';
import { ALL_USER_ROLES } from '../../constants/roles/userRoleTypes';
/**
 * Displays impersonation 'lip' that is below the header.
 *
 * @param props impersonation details
 * @returns {*} HTML content.
 */
const { BROKER , ASSISTER } = ALL_USER_ROLES;

const Impersonation = props => {
    const { impersonation, impersonationDetails, changeLang } = props;
    const { endpoints } = configs;
    const setDefaultLanguage = () => {
        localStorage.removeItem('HHID');
        localStorage.removeItem('HHID2');
        localStorage.removeItem('activeTabIndex');
        sessionStorage.language = 'English';
        changeLang(endpoints.CHANGE_LANGUAGE.processReplacements({ language: 'en' }));
        window.location.href = impersonationDetails.switchBackLink;
        sessionStorage.isInImpersonationMode = false;
        sessionStorage.impersonateHHID = '';
        sessionStorage.setItem('exitImpersonation', true);
    };

    const getImpersonationUserDisplayInfo = () => {
        switch (impersonationDetails.role) {
            case BROKER:
                return <FormattedMessage id='impersonation.viewing.agent' values={{ name:  impersonationDetails.name }}/>;
            case ASSISTER:
                return <FormattedMessage id='impersonation.viewing.assister' values={{ name:  impersonationDetails.name }}/>;    
            default:
                return <FormattedMessage id='impersonation.viewing' values={{ name:  impersonationDetails.name }}/>;
        }
    };

    return (
        <Fragment>
            { impersonation && impersonationDetails && impersonationDetails.name &&
                <div id="impersonation" className="grid-row">
                    <div>
                        <h4>
                            { getImpersonationUserDisplayInfo() }
                            <span>
                                <a
                                    href='#'
                                    className="usa-button gi-button gi-button__primary gi-button--small"
                                    onClick={() => setDefaultLanguage()}
                                >
                                    <FormattedMessage id='common.my_account'/>
                                </a>
                            </span>
                        </h4>
                    </div>
                </div>
            }
        </Fragment>

    );
};

export default Impersonation;
